import { updateName, updatePhoto } from '@auth/ManageUser';
import { uploadProfilePhoto } from '@db/Photos';
import { getAuthenticatedUser } from '@helpers/firebase/Auth';
import db, { updateDocWithTimestamps } from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { Photo, UserFormData } from '@types';
import { Place } from '@types';

export async function updateUser(
  displayName: string,
  username: string,
  hometown: Place,
  isPublic: boolean,
  profilePhoto?: Photo
) {
  const currentUser = getAuthenticatedUser();
  if (currentUser.displayName !== displayName) {
    await updateName(currentUser, displayName);
  }
  if (profilePhoto && profilePhoto.uri !== currentUser.photoURL) {
    const uploadedPhoto = await uploadProfilePhoto(profilePhoto);
    await updatePhoto(currentUser, uploadedPhoto);
  }
  await updateUserDoc({
    displayName,
    username,
    hometown,
    public: isPublic,
    photoUrl: currentUser.photoURL ? currentUser.photoURL : '',
  });
}

export async function updateUserDoc(userUpdate: Partial<UserFormData>) {
  const currentUser = getAuthenticatedUser();
  await updateDocWithTimestamps(db.doc(firestore, 'users', currentUser.uid), userUpdate);
}
